import { __assign, __rest } from "tslib";
import * as React from 'react';
/**
 * A button element using the defined kind of button.
 */
export var Button = function (_a) {
    var _b = _a.kind, kind = _b === void 0 ? 'success' : _b, children = _a.children, props = __rest(_a, ["kind", "children"]);
    return (React.createElement("button", __assign({}, props, { className: "btn btn-".concat(kind) }), children));
};
//# sourceMappingURL=index.js.map